import { Component, OnInit } from '@angular/core';
import { ModalService } from 'projects/app-shared/src/public-api';
import { EcommerceGenericoService } from 'projects/ecommerce-generico/src/public-api';

@Component({
  selector: 'modal-info-prov',
  templateUrl: './modal-info-prov.component.html',
  styleUrls: ['./modal-info-prov.component.scss']
})

export class ModalInfoProvComponent implements OnInit {

  constructor(private modal: ModalService, private genServ : EcommerceGenericoService) { }

  ngOnInit(): void {
  }

  aceptar() {
    this.modal.close('modal-info-prov');
  }

  get infoprov(){
    return this.genServ.getinfoProv()
  }

  get errorMessage() {
    return this.genServ.getErrorMessage();
  }

}
